import api from './api';

const aiPromptService = {
  // ============ KATEGORIEN ============
  
  getCategories: async () => {
    const response = await api.get('/ai-prompts/categories');
    return response.data;
  },

  createCategory: async (data) => {
    const response = await api.post('/ai-prompts/categories', data);
    return response.data;
  },

  updateCategory: async (id, data) => {
    const response = await api.put(`/ai-prompts/categories/${id}`, data);
    return response.data;
  },

  deleteCategory: async (id) => {
    const response = await api.delete(`/ai-prompts/categories/${id}`);
    return response.data;
  },

  reorderCategories: async (orderData) => {
    const response = await api.put('/ai-prompts/categories/reorder', orderData);
    return response.data;
  },

  // ============ PROMPTS ============
  
  getAll: async (params = {}) => {
    const response = await api.get('/ai-prompts', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/ai-prompts/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/ai-prompts', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/ai-prompts/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/ai-prompts/${id}`);
    return response.data;
  },

  toggleFavorite: async (id) => {
    const response = await api.post(`/ai-prompts/${id}/favorite`);
    return response.data;
  },

  sendToAssistant: async (id, sessionId = null) => {
    const response = await api.post(`/ai-prompts/${id}/send-to-assistant`, null, {
      params: sessionId ? { session_id: sessionId } : {}
    });
    return response.data;
  },

  createFromTask: async (taskId, categoryId = null) => {
    const response = await api.post('/ai-prompts/from-task', null, {
      params: { task_id: taskId, category_id: categoryId }
    });
    return response.data;
  },
};

export default aiPromptService;
